import React, { Component } from 'react'
import StyleSheet from 'styles'
import { SnackbarActions } from 'actionsets'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'

const SNACKBAR_SHOW_TIME = 3000

export class Snackbar extends Component{

  state = {
    visible: false
  }

  constructor(props){
    super(props)
    SnackbarActions.bindActions(this)
  }

  static getDerivedStateFromProps(nextProps, prevState={}) {
    return {...prevState, visible: !! nextProps.message}
  }

  componentDidUpdate = () => {
    const {message: visible} = this.props
    window.clearTimeout(this.hideTimer)
    if(visible)
      this.hideTimer = window.setTimeout(this.actions.clear, SNACKBAR_SHOW_TIME)
  }

  has = status => this.props.status === status

  render = () =>
    <div onClick={this.actions.clear} className={styles('snackbar', {down: !this.state.visible, error: this.has('error'), warning: this.has('warning'), success: this.has('success'), notice: this.has('notice')})}>
      <Typography variant="subtitle1" className={styles.message}>
        {this.props.message}
      </Typography>
    </div>

}

const styles = StyleSheet({
  snackbar: {
    top: -2,
    height: 35,
    textAlign: 'center',
    background: 'none',
    transition: 'all 200ms',
    overflow: 'hidden',
    position: 'absolute',
    cursor: 'pointer',
    '@media (max-width: 600px)': {
      zIndex: 100,
    }
  },
  down: {
    height: 0
  },
  error: {
    background: 'rgba(234, 81, 66, 0.7)',
  },
  warning: {
    background: 'rgba(234, 81, 66, 0.7)',
  },
  success: {
    background: 'rgba(16, 248, 185, 0.7)',
  },
  notice: {
    background: 'rgba(16, 248, 185, 0.7)',
  },
  message: {
    width: '100vw',
    height: 32,
    pointerEvents: 'none',
    padding: '6px 10px 4px 10px',
    display: 'inline-block',
    color: '#20173A',
    opacity: 0.7,
    textAlign: 'center',
  }
})

export default connect(({snackbar}) => snackbar)(Snackbar)